import React from 'react';

/**
 * StatusPill — machine online/offline/warn state indicator
 * variant: 'online' | 'offline' | 'warn'
 */
export default function StatusPill({ variant = 'offline', label, style }) {
  const text = label ?? (variant === 'online' ? 'Online' : variant === 'warn' ? 'Warning' : 'Offline');
  return (
    <span className={`status-pill ${variant}`} style={style}>
      <span className="dot" />
      {text}
    </span>
  );
}
